import { service } from '@ember/service';
import DataViewRoute from 'cpc-license-manager/utils/data-view-route';

export default class LicensesRoute extends DataViewRoute {
  @service store;

  model(params) {
    this.setPagination(params);
    return this.store.query('license', params);
  }

  setupController(controller, model) {
    Object.assign(controller, {
      totalRecords: model.meta.count ?? 0,
      model,
    });
  }
}
